<div *ngIf="(vm$ | async) as vm" class="p-3 table-data-root">

    <div *ngIf="vm.workingText">
        <span>{{vm.workingText}}</span>
    </div>
    <div *ngIf="vm.errorText">
        <h1 class="text-danger">{{vm.errorText}}</h1>
    </div>

    <div *ngIf="!vm.workingText && !vm.errorText">

        <!-- title -->
        <div class="row" *ngIf="vm.def.title">
            <div class="col-md-12">
                <h1>{{vm.def.title}}</h1>
            </div>
        </div>

        <!-- params -->
        <div class="row align-items-end params-row-tight">
            <div class="col-md-4" *ngFor="let i of vm.items">
                <div *ngIf="i.def.entryType == 'input'" class="mx-2">
                    <div class="md-form form-group">

                        <input mdbInput [type]="i.def.inputType" mdbInput class="form-control" [id]="i.def.code"
                            [name]="i.def.code" [required]="i.def.required" [ngModel]="i.modelGet()"
                            (ngModelChange)="i.modelSet($event)" [ngModelOptions]="{standalone: true}">
                        <ng-template #popTemplate>
                            <div>
                                <span>{{i.def.helpText}}</span>
                            </div>
                        </ng-template>
                        <label [for]="i.def.code" style="cursor: pointer;" [mdbPopoverHeader]="i.def.title"
                            [mdbPopover]="popTemplate" triggers="hover">{{i.def.title}}
                        </label>
                    </div>
                </div>
                <div *ngIf="i.def.entryType == 'select'" class="mx-2">
                    <div class="md-form form-group">
                        <ng-template #popTemplate>
                            <div>
                                <span>{{i.def.helpText}}</span>
                            </div>
                        </ng-template>
                        <!--<label style="cursor: pointer;" class="pb-1" [mdbPopoverHeader]="i.def.title" [mdbPopover]="popTemplate" triggers="hover">{{i.def.title}}
                        </label>-->
                        <mdb-select [ngModel]="selectedValue" (ngModelChange)="i.modelSet($event)" #select_ref="ngModel"
                            [options]="i.def.selectItems" [placeholder]="i.def.helpText">

                        </mdb-select>
                    </div>
                </div>
            </div>
            <div class="col-md-12 col-lg-auto d-flex justify-content-start pl-2" *ngIf="isEventsRole">
                <div *ngIf='(vmTable$ | async) as vmTable' class="d-flex justify-content-start flex-wrap mt-0">
                    <button mdbBtn color="primary" class="waves-dark" type="button" outline="true" size="md"
                        (click)="view(vm, vmTable, 0)" mdbWavesEffect>View</button>
                    <button mdbBtn color="primary" class="waves-dark" type="button" outline="true" size="md"
                        *ngIf="allowExport" (click)="export(vm, vmTable, 0)" mdbWavesEffect>Export</button>
                    <a *ngIf="allowReload && vmTable.rows?.length > 0 && !vmTable.workingText" mdbBtn floating="true" size="sm"
                        style="width: 26px; height: 26px; padding: 0; display: inline-flex; align-items: center; justify-content: center;"
                        gradient="blue" mdbWavesEffect (click)="view(vm, vmTable, 1)" mdbTooltip="Reload">
                        <mdb-icon fas icon="redo-alt" style="font-size: 10px; line-height: 1; display: inline-block; transform: scale(0.72); transform-origin: center;"></mdb-icon>
                    </a>
                </div>
            </div>
        </div>

        <!-- table -->
        <div class="row table-row-tight">
            <div class="col-md-12">

                <div *ngIf='(vmTable$ | async) as vmTable'>

                    <!-- toolbar -->
                    <div class="d-flex justify-content-start flex-wrap">
                        <button mdbBtn color="primary" class="waves-dark" type="button" outline="true" size="md" *ngIf="!isEventsRole"
                            (click)="view(vm, vmTable, 0)" mdbWavesEffect>View</button>
                        <button mdbBtn color="primary" class="waves-dark" type="button" outline="true" size="md" *ngIf="allowExport && !isEventsRole"
                            (click)="export(vm, vmTable, 0)" mdbWavesEffect>Export</button>
                        <a *ngIf="allowReload && vmTable.rows?.length > 0 && !vmTable.workingText && !isEventsRole" mdbBtn floating="true" size="sm"
                            style="width: 26px; height: 26px; padding: 0; display: inline-flex; align-items: center; justify-content: center;"
                            gradient="blue" mdbWavesEffect
                            (click)="view(vm, vmTable, 1)" mdbTooltip="Reload">
                            <mdb-icon fas icon="redo-alt" style="font-size: 10px; line-height: 1; display: inline-block; transform: scale(0.72); transform-origin: center;"></mdb-icon>
                        </a>

                    </div>

                    <div class="d-flex justify-content-start flex-wrap" *ngIf="allowEmail">
                        <input mdbInput type="text" class="form-control ml-2 mt-2" style="width: 30%;"
                            placeholder="email address" [(ngModel)]="vm.emailAddress">
                        <button mdbBtn color="primary" class="waves-dark" type="button" outline="true" size="md"
                            (click)="email(vm, vmTable, 0)" mdbWavesEffect>Email</button>
                    </div>


                    <div *ngIf="vmTable.workingText">
                        <span>{{vmTable.workingText}}</span>
                    </div>
                    <div *ngIf="vmTable.errorText">
                        <h1 class="text-danger">{{vmTable.errorText}}</h1>
                    </div>
                    <div *ngIf="vmTable.actionText">
                        <h1 class="text-success">{{vmTable.actionText}}</h1>
                    </div>
                    <div *ngIf="vmTable.dataLimitMessage">
                        <br />
                        <h5 class="text-info">{{vmTable.dataLimitMessage}}</h5>
                    </div>

                    <div *ngIf="!vmTable.workingText && !vmTable.errorText && vmTable.rows && vmTable.rows.length > 0">
                        <div class="row mt-0">
                            <!-- left side -->
                            <div class="col-md-8 mr-0">
                            </div>

                            <!-- right side -->
                            <div class="col-md-4 mb-0">
                                <!-- Search form -->
                                <div class="form-inline md-form form-sm my-0">
                                    <mdb-icon fas icon="search" aria-hidden="true"></mdb-icon>
                                    <input class="form-control form-control-sm ml-5 w-75" type="search"
                                        [ngModel]="searchData" (ngModelChange)="doDataSearch(vmTable, $event)"
                                        placeholder="Search text">
                                </div>
                            </div>
                        </div>
                        <div *ngIf="!vmTable.groupedVm" class="row mt-0">
                            <div class="col-md-12 table-responsive px-0 mobile-scroll-wrap" #mobileScrollWrap (scroll)="onTableWrapScroll($event)">
                            <table mdbTable small="true" striped="true" responsive="true" class="mobile-scroll-table">
                                <thead class="table-dark">
                                    <tr mdbTableCol>
                                        <th class="border border-light" *ngFor="let c of vmTable.columns; index as i"
                                            [style]="setHeaderStyle(i, vmTable)">
                                            <span style="font-size:small; white-space: nowrap;">{{c}}</span>&nbsp;
                                            <mdb-icon style="color:white;" fas icon={{vmTable.iconNames[i]}}
                                                (click)="onSort(i, vmTable)" class="prefix"></mdb-icon>
                                        </th>
                                    </tr>
                                </thead>

                                <tbody>
                                    <tr *ngFor="let r of vmTable.rowsFiltered; index as rix">
                                        <td class="border text-wrap border-dark"
                                            style="font-size:x-small; white-space: nowrap;"
                                            *ngFor="let f of r; index as idx">
                                            <ng-template #tooltipPopTemplate>
                                                <div class="tooltip-sections-wrap">
                                                    <div class="d-flex justify-content-between align-items-center border-bottom mb-2 pb-1">
                                                        <strong class="tooltip-header-title">Details <span *ngIf="getRowConfirmationNumber(vmTable, r)">- {{getRowConfirmationNumber(vmTable, r)}}</span></strong>
                                                        <button type="button" class="close tooltip-close-btn" aria-label="Close"
                                                            (click)="closeTooltip($event)">
                                                            <span aria-hidden="true">&times;</span>
                                                        </button>
                                                    </div>
                                                    <ng-container *ngIf="getTooltipSections(getRowTooltipPayload(vmTable, r, rix)) as sections">
                                                        <div class="tooltip-section-card" *ngFor="let s of getSectionsBeforeRouteCard(sections)">
                                                            <div class="py-1 px-2 border-bottom bg-light">
                                                                <strong>{{s.title}}</strong>
                                                            </div>
                                                            <div class="py-1 px-2 bg-white">
                                                                <div class="tooltip-field-row" *ngFor="let sf of s.fields">
                                                                    <span class="font-weight-bold" *ngIf="sf.label">{{sf.label}}:</span>
                                                                    <span>{{sf.value}}</span>
                                                                </div>
                                                            </div>
                                                        </div>

                                                        <div class="tooltip-section-card" *ngIf="getRouteSections(sections).length > 0">
                                                            <div class="py-1 px-2 border-bottom bg-light">
                                                                <strong>Route</strong>
                                                            </div>
                                                            <div class="py-1 px-2 bg-white">
                                                                <div class="tooltip-route-item" *ngFor="let rs of getRouteSections(sections); let isLast = last">
                                                                    <div class="tooltip-route-marker-wrap">
                                                                        <mdb-icon fas icon="map-marker-alt" class="tooltip-route-marker"></mdb-icon>
                                                                        <span class="tooltip-route-line" *ngIf="!isLast"></span>
                                                                    </div>
                                                                    <div class="tooltip-route-content">
                                                                        <div class="tooltip-route-title">{{rs.title}}</div>
                                                                        <div class="tooltip-route-detail" *ngFor="let sf of rs.fields">
                                                                            <span>{{sf.value}}</span>
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </div>

                                                        <div class="tooltip-section-card" *ngFor="let s of getSectionsAfterRouteCard(sections)">
                                                            <div class="py-1 px-2 border-bottom bg-light">
                                                                <strong>{{s.title}}</strong>
                                                            </div>
                                                            <div class="py-1 px-2 bg-white">
                                                                <div class="tooltip-field-row" *ngFor="let sf of s.fields">
                                                                    <span class="font-weight-bold" *ngIf="sf.label">{{sf.label}}:</span>
                                                                    <span>{{sf.value}}</span>
                                                                </div>
                                                            </div>
                                                        </div>
                                                        <div *ngIf="sections.length == 0" class="small text-muted py-1">
                                                            No details available.
                                                        </div>
                                                    </ng-container>
                                                </div>
                                            </ng-template>

                                            <span *ngIf="!isSpecialCell(f, idx, vmTable)" [style]="setColumnStyle(idx, vmTable)" class="d-inline-flex align-items-center">
                                                <strong>{{getCellDisplayValue(f, idx, vmTable)}}</strong>
                                                <mdb-icon *ngIf="isEventsRole && isResTooltipColumn(vmTable, idx) && getRowTooltipPayload(vmTable, r, rix)"
                                                    #tooltipPopover="mdb-tooltip" fas icon="eye" class="ml-1 text-info tooltip-eye-icon"
                                                    (click)="onTooltipIconClick(tooltipPopover)"
                                                    [mdbTooltip]="tooltipPopTemplate" triggers="click" container="body" placement="left"></mdb-icon>
                                            </span>

                                            <div *ngIf="isSpecialCell(f, idx, vmTable)">
                                                <a *ngIf="isPhone(f)" [href]="'tel:' + f">{{f}}</a>

                                                <div *ngIf="isList(f)">
                                                    <div *ngFor="let f2 of list(f)">
                                                        <strong>- {{f2}}</strong>
                                                    </div>
                                                </div>

                                                <div *ngIf="isCsv(f)">
                                                    <div *ngFor="let f2 of csv(f)">
                                                        <a *ngIf="isPhone(f2)" [href]="'tel:' + f2">{{f2}}</a>
                                                        <strong *ngIf="!isPhone(f2)">{{f2}}</strong>
                                                    </div>
                                                </div>

                                            </div>

                                            <mdb-icon *ngIf="isSpecialCell(f, idx, vmTable) && isEventsRole && isResTooltipColumn(vmTable, idx) && getRowTooltipPayload(vmTable, r, rix)"
                                                #tooltipPopover="mdb-tooltip" fas icon="eye" class="ml-1 text-info tooltip-eye-icon"
                                                (click)="onTooltipIconClick(tooltipPopover)"
                                                [mdbTooltip]="tooltipPopTemplate" triggers="click" container="body" placement="left"></mdb-icon>

                                        </td>
                                    </tr>
                                </tbody>

                            </table>
                            </div>
                        </div>
                        <div *ngIf="vmTable.groupedVm" class="row mt-1">
                            <div class="col-md-12">
                                <div class="table-responsive px-0 mobile-scroll-wrap" #mobileScrollWrap (scroll)="onTableWrapScroll($event)">
                                <table mdbTable small="true" striped="true" responsive="true" class="mobile-scroll-table">
                                    <thead class="table-dark">
                                        <tr mdbTableCol>
                                            <th class="border border-light text-center"
                                                *ngFor="let c of vmTable.groupedVm.columns">{{c}}</th>
                                        </tr>
                                    </thead>

                                    <tbody>
                                        <tr mdbTableCol *ngFor="let r of vmTable.groupedVm.filteredRows">
                                            <td class="border border-dark" *ngFor="let f of r.cells"
                                                [ngStyle]="{ 'width': vmTable.groupedVm.styleWidth }">
                                                <div class="d-flex" *ngFor="let cr of f.cellRows">
                                                    <div class="text-right p-1" style="width: 50%;">
                                                        <span class="font-weight-bold">{{cr.title}}</span>
                                                    </div>
                                                    <div class="p-1" style="width: 40%">
                                                        <span>{{cr.value}}</span>
                                                    </div>
                                                </div>
                                            </td>
                                        </tr>
                                    </tbody>

                                </table>
                                </div>
                            </div>
                        </div>

                        <div class="mobile-floating-scrollbar" *ngIf="showFloatingScrollbar" #floatingScrollbar
                            (scroll)="onFloatingScrollbarScroll()">
                            <div class="mobile-floating-scrollbar-content" #floatingScrollbarContent></div>
                        </div>
                    </div>

                </div>
            </div>
        </div>

        <!-- Reason windows-->
        <div *ngIf="vm.reasonFormVm as rvm" class="my-6">
            <div class="row">
                <div class="col-md-8 offset-md-2">
                    <mdb-card narrower="true" cascade="true">
                        <mdb-card-body cascade="true">
                            <div class="row mt-n4 mb-n4" *ngIf="rvm.reasonAnswerVm1">
                                <div class="col-md-12">
                                    <div class="mx-2">
                                        <div class="md-form form-group form-sm">
                                            <app-form-input [vm]="rvm.reasonAnswerVm1"
                                                (textChanged)="reasonFormValidate(vm, rvm)"></app-form-input>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="row mt-n4 mb-n4" *ngIf="rvm.reasonAnswerVm2">
                                <div class="col-md-12">
                                    <div class="mx-2">
                                        <div class="md-form form-group form-sm">
                                            <app-form-input [vm]="rvm.reasonAnswerVm2"
                                                (textChanged)="reasonFormValidate(vm, rvm)"></app-form-input>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="row mt-n4 mb-n4" *ngIf="rvm.reasonAnswerVm3">
                                <div class="col-md-12">
                                    <div class="mx-2">
                                        <div class="md-form form-group form-sm">
                                            <app-form-input [vm]="rvm.reasonAnswerVm3"
                                                (textChanged)="reasonFormValidate(vm, rvm)"></app-form-input>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="row mt-n4 mb-n4" *ngIf="rvm.reasonAnswerVm4">
                                <div class="col-md-12">
                                    <div class="mx-2">
                                        <div class="md-form form-group form-sm">
                                            <app-form-input [vm]="rvm.reasonAnswerVm4"
                                                (textChanged)="reasonFormValidate(vm, rvm)"></app-form-input>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="row mt-n4 mb-n4" *ngIf="rvm.reasonAnswerVm5">
                                <div class="col-md-12">
                                    <div class="mx-2">
                                        <div class="md-form form-group form-sm">
                                            <app-form-input [vm]="rvm.reasonAnswerVm5"
                                                (textChanged)="reasonFormValidate(vm, rvm)"></app-form-input>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="row d-flex justify-content-center">
                                <app-form-ok-cancel [vm]="rvm.okCancelVm" (cancelClicked)="reasonFormCanceled(vm)"
                                    [isInvalid]="!rvm.isValid" (okClicked)="reasonFormOk(vm, rvm)">
                                </app-form-ok-cancel>
                            </div>
                        </mdb-card-body>
                    </mdb-card>
                </div>
            </div>
        </div>

    </div>

</div>